module.exports = __webpack_public_path__ + "static/media/404.77e1571b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/404.svg
// module id = 1346
// module chunks = 0